export function formatNumber(input) {
  // Convert input to a number if it's a string.
  let number;
  if (typeof input === "string") {
    number = Number(input);
  } else if (typeof input === "number") {
    number = input;
  } else {
    // If it's neither a string nor a number, return an error message or handle as needed.
    return "Invalid input type";
  }

  // Check if conversion resulted in a valid number.
  if (isNaN(number)) {
    return "Invalid number";
  }

  // Format the number for the German locale.
  // For example, 20000 becomes "20.000".
  return number.toLocaleString("de-DE");
}
